import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";
import PublicApp from "./PublicApp";
import publicI18n from "./i18n/publicI18n";
import "./public.css";

if (typeof window !== "undefined") {
  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          setInterval(() => {
            registration.update();
          }, 5 * 60 * 1000);
        })
        .catch(() => {});
    });
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <I18nextProvider i18n={publicI18n}>
      <PublicApp />
    </I18nextProvider>
  </HelmetProvider>,
);
